import * as yup from 'yup';

export const messageSchema = yup.object().shape({
  message_name: yup.string().required('É necessário informar o nome da mensagem.'),
});
